<template>
    <div class="bg-white flex flex-col gap-1 overflow-hidden shadow rounded-lg px-3 py-8 text-sm sm:text-base">
        <span>Click The Button To Go To The New Spritesheet Uploader</span>
        <a href="http://51.20.94.15:8000" target="_blank" class="btn-primary light-blue self-start"> New Spritesheet Uploader </a>
    </div>
</template>
